export * from "./ActionsTab";
export * from "./ActivityPropertiesTab";
export * from "./ParticipantsTab";
export * from "./TransitionPropertiesTab";
export * from "./TransitionsFromToTab";
export * from "./TriggersTab";
